// Sound effects for the trading cards, made with the Web Audio API so there are no audio files to load.

const VOLUME = 0.25;

let context = null;

// Browsers only allow sound after a click, so the audio context is made the first time a sound is played
function audio() {
    let AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) {
        return null;
    }
    if (!context) {
        context = new AudioContext();
    }
    if (context.state === 'suspended') {
        context.resume();
    }
    return context;
}

// One note: fades in quickly and rings out over `length` seconds
function tone(ctx, type, frequency, start, length, peak) {
    let osc = ctx.createOscillator();
    let gain = ctx.createGain();
    osc.type = type;
    osc.frequency.setValueAtTime(frequency, start);
    gain.gain.setValueAtTime(0.0001, start);
    gain.gain.exponentialRampToValueAtTime(peak * VOLUME, start + 0.015);
    gain.gain.exponentialRampToValueAtTime(0.0001, start + length);
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start(start);
    osc.stop(start + length + 0.05);
    return osc;
}

// Tearing open the wrapper: a burst of hiss that sweeps upward, with a low thump underneath
export function playPackOpen() {
    let ctx = audio();
    if (!ctx) {
        return;
    }
    let now = ctx.currentTime;
    let length = 0.45;

    let buffer = ctx.createBuffer(1, Math.floor(ctx.sampleRate * length), ctx.sampleRate);
    let data = buffer.getChannelData(0);
    for (let i = 0; i < data.length; i++) {
        data[i] = Math.random() * 2 - 1;
    }
    let noise = ctx.createBufferSource();
    noise.buffer = buffer;
    let filter = ctx.createBiquadFilter();
    filter.type = 'bandpass';
    filter.Q.value = 1.2;
    filter.frequency.setValueAtTime(500, now);
    filter.frequency.exponentialRampToValueAtTime(6000, now + length);
    let gain = ctx.createGain();
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(0.9 * VOLUME, now + 0.05);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + length);
    noise.connect(filter);
    filter.connect(gain);
    gain.connect(ctx.destination);
    noise.start(now);

    let thump = tone(ctx, 'sine', 160, now, 0.25, 0.9);
    thump.frequency.exponentialRampToValueAtTime(50, now + 0.25);
}

// A Legendary or Trimmed card turning over: a bright rising chime
export function playSpecialReveal() {
    let ctx = audio();
    if (!ctx) {
        return;
    }
    let now = ctx.currentTime;
    // C6, E6, G6, C7
    [1046.5, 1318.5, 1568, 2093].forEach((frequency, i) => {
        let start = now + i * 0.08;
        tone(ctx, 'triangle', frequency, start, 0.9, 0.5);
        tone(ctx, 'sine', frequency * 2, start, 0.5, 0.15);
    });
}

// A Mystic card turning over: a rising shimmer, a fast run of bells up two octaves, then a wide chord that rings out
export function playMysticReveal() {
    let ctx = audio();
    if (!ctx) {
        return;
    }
    let now = ctx.currentTime;

    // the shimmer: hiss swept upward through a narrow filter
    let length = 0.7;
    let buffer = ctx.createBuffer(1, Math.floor(ctx.sampleRate * length), ctx.sampleRate);
    let data = buffer.getChannelData(0);
    for (let i = 0; i < data.length; i++) {
        data[i] = Math.random() * 2 - 1;
    }
    let noise = ctx.createBufferSource();
    noise.buffer = buffer;
    let filter = ctx.createBiquadFilter();
    filter.type = 'bandpass';
    filter.Q.value = 6;
    filter.frequency.setValueAtTime(1200, now);
    filter.frequency.exponentialRampToValueAtTime(9000, now + length);
    let hiss = ctx.createGain();
    hiss.gain.setValueAtTime(0.0001, now);
    hiss.gain.exponentialRampToValueAtTime(0.5 * VOLUME, now + length * 0.7);
    hiss.gain.exponentialRampToValueAtTime(0.0001, now + length);
    noise.connect(filter);
    filter.connect(hiss);
    hiss.connect(ctx.destination);
    noise.start(now);

    // a low swell underneath that drops away as the bells start
    let swell = tone(ctx, 'sine', 110, now, 1.2, 0.6);
    swell.frequency.exponentialRampToValueAtTime(220, now + 0.6);

    // the run: E major pentatonic from E5 up to E7, each bell with a slightly sharp twin so it shimmers
    let run = [659.3, 740, 830.6, 987.8, 1108.7, 1318.5, 1480, 1661.2, 1975.5, 2217.5, 2637];
    run.forEach((frequency, i) => {
        let start = now + 0.25 + i * 0.055;
        tone(ctx, 'triangle', frequency, start, 0.6, 0.32);
        tone(ctx, 'sine', frequency * 1.006, start, 0.6, 0.18);
    });

    // the chord it lands on: E, G sharp, B and a high E, held and left to fade
    let landing = now + 0.25 + run.length * 0.055;
    [659.3, 830.6, 987.8, 1318.5, 2637].forEach((frequency, i) => {
        tone(ctx, 'triangle', frequency, landing, 2.4, 0.3);
        tone(ctx, 'sine', frequency * (i % 2 ? 1.004 : 0.996), landing, 2.4, 0.2);
    });
    // two last sparkles over the chord
    tone(ctx, 'sine', 3951, landing + 0.18, 0.9, 0.16);
    tone(ctx, 'sine', 5274, landing + 0.36, 1.1, 0.12);
}
